import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, IAtualizarDareState } from './types';

export const INITIAL_STATE: IAtualizarDareState = {
	status: 0,
	data: null,
	numeroDare: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): IAtualizarDareState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_DARE_REQUEST: {
				draft.numeroDare = action.payload.numeroDare;
				break;
			}
			case Types.ATUALIZAR_DARE_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.ATUALIZAR_DARE_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.ATUALIZAR_DARE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
